
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Forceurbaniarentperkm() {



    const cardData =
    {
        keyword: 'Force Urbania Rent Per km in Pune  ',
        heading: 'Amruta Travels: Force Urbania Rent Per km in Pune  ',
        headingDescription: 'Amruta Travels offers Force Urbania Rent Per km in Pune, providing affordable and transparent pricing for group travel across the city and nearby destinations. Whether it’s a corporate trip, family outing, wedding transport, airport transfer, or weekend getaway, our 13-seater and 17-seater Force Urbania vans offer spacious interiors, air-conditioning, and modern amenities for a comfortable journey. With professional drivers, punctual service, competitive rates, and 24/7 support, Amruta Travels ensures your Force Urbania rental in Pune is convenient, safe, and hassle-free.',


        top: 'Top Places to Visit in Pune with Amruta Travels',

    "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas of the Maratha Empire, Shaniwar Wada is a historic fort in central Pune. Known for its massive Delhi Gate, beautiful gardens, and tales of royal intrigue, it's a major attraction. Don't miss the evening light and sound show that narrates its rich past."
  },
  {
    "title": "Aga Khan Palace",
    "description": "An architectural gem and a symbol of India’s freedom struggle, the Aga Khan Palace was built in 1892. It once housed Mahatma Gandhi and his wife Kasturba. Today, it features a museum with personal artifacts, peaceful gardens, and memorials."
  },
  {
    "title": "Sinhagad Fort",
    "description": "This hilltop fort, located 35 km from Pune, is famous for its historic Battle of Sinhagad and stunning views. A popular trekking destination, it offers visitors a mix of adventure, history, and local Maharashtrian snacks like pithla-bhakri."
  },
  {
    "title": "Osho Ashram",
    "description": "Nestled in the lush greenery of Koregaon Park, Osho International Meditation Resort is a spiritual retreat offering meditation, wellness workshops, and mindfulness programs. It attracts global visitors looking for peace and transformation."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, this rock-cut temple dedicated to Lord Shiva is carved from a single basalt rock. Located in the heart of Pune, it’s a peaceful oasis amidst the city bustle with detailed stone carvings and spiritual ambiance."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This one-of-a-kind museum showcases over 20,000 artifacts including musical instruments, weapons, sculptures, and art pieces. It’s a window into India’s rich cultural history, curated lovingly by Dr. Dinkar Kelkar in memory of his son."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "A popular weekend spot just outside Pune, Khadakwasla Dam is perfect for a scenic drive, evening stroll, or picnic. The serene waters, cool breeze, and roadside food vendors make it a relaxing escape from the city."
  },
  {
    "title": "Fergusson College Road",
    "description": "A youthful and energetic area filled with cafes, eateries, and shopping outlets, Fergusson College Road is a go-to spot for college students and tourists alike. From fashion finds to tasty street food, it offers a lively Pune experience."
  },
  {
    "title": "Lal Mahal",
    "description": "Originally built in the 1630s by Shahaji Bhosale, Lal Mahal is linked to the childhood of Chhatrapati Shivaji Maharaj. The reconstructed palace features exhibits and murals depicting the Maratha warrior’s early life and battles."
  },
  {
    "title": "Pune-Okayama Friendship Garden",
    "description": "Inspired by Japan’s Korakuen Garden, this beautifully landscaped park features flowing streams, stone bridges, koi ponds, and walking paths. It's a serene and photogenic spot ideal for families and couples."
  }
],



"services": [
  {
    "name": "Force Urbania rent per km in Pune",
    "description": "Force Urbania rent per km in Pune with AC interiors, cushioned seating, luggage-friendly space, and professional drivers. Perfect for city travel, airport transfers, corporate trips, or short outstation journeys with transparent per km pricing."
  },
  {
    "name": "Force Urbania per km rate Pune",
    "description": "Get Force Urbania per km rates in Pune for comfortable and convenient travel. Vehicles come with air-conditioning, cushioned seats, ample luggage space, and trained drivers for safe and luxurious city or outstation trips."
  },
  {
    "name": "Urbania rent per km Pune",
    "description": "Urbania rent per km in Pune for families, corporate groups, or friends. Fully AC interiors, cushioned seating, luggage space, and professional drivers ensure a smooth, safe, and stress-free ride at competitive per km rates."
  },
  {
    "name": "Urbania per km charges Pune",
    "description": "Urbania per km charges in Pune with transparent pricing for city travel or short outstation trips. Comfortable AC interiors, cushioned seats, ample luggage space, and professional drivers make every journey enjoyable and hassle-free."
  },
  {
    "name": "Force Urbania rental cost per km Pune",
    "description": "Force Urbania rental cost per km in Pune for family trips, corporate travel, or airport transfers. AC-equipped interiors, cushioned seating, luggage-friendly design, and trained drivers ensure a luxurious and safe travel experience."
  },
  {
    "name": "Urbania hire per km Pune",
    "description": "Urbania hire per km in Pune with fully AC interiors, cushioned seats, luggage-friendly space, and professional drivers. Ideal for city tours, airport transfers, corporate travel, or short outstation trips at affordable rates."
  },
  {
    "name": "Urbania Bus rent per km Pune",
    "description": "Urbania bus rent per km in Pune for group travel, corporate events, or family trips. Vehicles offer AC interiors, cushioned seating, luggage space, and experienced drivers, ensuring a comfortable and reliable travel experience."
  },
  {
    "name": "Force Urbania price per km Pune",
    "description": "Check Force Urbania price per km in Pune for city travel, airport transfers, or outstation trips. Vehicles are fully AC, have cushioned seating, luggage-friendly interiors, and professional drivers to ensure a luxurious journey."
  },
  {
    "name": "Force Urbania rent per km in Baner Pune",
    "description": "Force Urbania rent per km in Baner Pune with AC, cushioned seating, luggage-friendly interiors, and professional drivers. Ideal for city tours, airport transfers, corporate travel, and weekend trips with transparent per km charges."
  },
  {
    "name": "Urbania per km rate in Kharadi Pune",
    "description": "Urbania per km rate in Kharadi Pune for families, corporate travel, or outstation trips. Vehicles come with AC, cushioned seats, luggage-friendly interiors, and experienced drivers for a comfortable and reliable journey."
  },
  {
    "name": "Force Urbania per km charges Hadapsar Pune",
    "description": "Force Urbania per km charges in Hadapsar Pune for city travel, airport transfers, or outstation trips. AC-equipped interiors, cushioned seating, luggage-friendly design, and professional drivers ensure safe, comfortable, and enjoyable travel."
  },
  {
    "name": "Urbania rent per km Hinjewadi Pune",
    "description": "Urbania rent per km in Hinjewadi Pune with AC, cushioned seating, ample luggage space, and trained drivers. Perfect for corporate travel, family trips, or weekend getaways with competitive per km pricing."
  },
  {
    "name": "Force Urbania rental per km Wakad Pune",
    "description": "Force Urbania rental per km in Wakad Pune for city travel, airport transfers, or corporate outings. Luxury interiors, AC, cushioned seating, luggage space, and professional drivers ensure a smooth, stress-free journey."
  },
  {
    "name": "Urbania per km cost Kothrud Pune",
    "description": "Urbania per km cost in Kothrud Pune for family trips, corporate travel, or city tours. AC interiors, cushioned seating, luggage-friendly design, and professional drivers make every trip safe, comfortable, and enjoyable."
  },
  {
    "name": "Force Urbania rent per km Pimpri Chinchwad",
    "description": "Force Urbania rent per km in Pimpri Chinchwad for local travel or short outstation trips. Vehicles with AC, cushioned seating, luggage space, and trained drivers provide a luxurious, comfortable, and safe journey."
  },
  {
    "name": "Urbania per km rate PCMC",
    "description": "Urbania per km rate in PCMC for families, corporate groups, or small tour parties. Fully AC interiors, cushioned seating, luggage space, and professional drivers ensure a safe, convenient, and luxurious travel experience."
  },
  {
    "name": "Force Urbania per km charges Pimpri",
    "description": "Force Urbania per km charges in Pimpri for city travel, corporate trips, or airport transfers. Vehicles come with AC, cushioned seats, ample luggage space, and professional drivers for a safe and comfortable ride."
  },
  {
    "name": "Urbania rent per km Chinchwad",
    "description": "Urbania rent per km in Chinchwad for families, groups, or corporate travel. AC interiors, cushioned seating, luggage-friendly design, and professional drivers make city and short outstation trips comfortable, safe, and enjoyable."
  }
],
"tableData": [
  ["Force Urbania rent per km in Pune", "Force Urbania per km rate Pune"],
  ["Urbania rent per km Pune", "Urbania per km charges Pune"],
  ["Force Urbania rental cost per km Pune", "Urbania hire per km Pune"],
  ["Urbania Bus rent per km Pune", "Force Urbania price per km Pune"],
  ["Force Urbania rent per km in Baner Pune", "Urbania per km rate in Kharadi Pune"],
  ["Force Urbania per km charges Hadapsar Pune", "Urbania rent per km Hinjewadi Pune"],
  ["Force Urbania rental per km Wakad Pune", "Urbania per km cost Kothrud Pune"],
  ["Force Urbania rent per km Pimpri Chinchwad", "Urbania per km rate PCMC"],
  ["Force Urbania per km charges Pimpri", "Urbania rent per km Chinchwad"]
],




"whychoose": [
  {
    "WhyChooseheading": "Affordable Force Urbania Rent Per KM in Pune",
    "WhyChoosedescription": "Amruta Travels offers transparent and competitive Force Urbania rent per km in Pune. Enjoy premium travel without hidden charges, making it ideal for both short city trips and long journeys."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Family, and VIP Travel",
    "WhyChoosedescription": "Whether it’s a corporate outing, family trip, or VIP transport, our per km rental ensures cost-effective, comfortable, and stylish travel in Pune and surrounding areas."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Interiors",
    "WhyChoosedescription": "The Force Urbania features plush seating, generous legroom, air conditioning, large windows, and ample luggage space, making every kilometer of your journey smooth and enjoyable."
  },
  {
    "WhyChooseheading": "Professional and Courteous Drivers",
    "WhyChoosedescription": "All rentals include skilled drivers who ensure a safe, punctual, and comfortable ride, experienced in handling the Force Urbania for city and outstation trips."
  },
  {
    "WhyChooseheading": "Transparent Pricing and No Hidden Costs",
    "WhyChoosedescription": "Our per km pricing is upfront and clear. You pay only for the distance traveled, making it a smart and economical choice for group travel in Pune."
  },
  {
    "WhyChooseheading": "Regularly Maintained and Hygienic Vehicles",
    "WhyChoosedescription": "All Force Urbania vehicles are regularly serviced and sanitized, ensuring maximum safety, hygiene, and comfort throughout your trip."
  },
  {
    "WhyChooseheading": "Flexible Pickup, Drop-Off, and Custom Routes",
    "WhyChoosedescription": "We provide flexible pickup and drop-off options along with customizable routes tailored to your schedule, making travel convenient and stress-free."
  },
  {
    "WhyChooseheading": "Easy Booking with Dedicated Support",
    "WhyChoosedescription": "Booking a Force Urbania on a per km basis in Pune is quick and hassle-free. Our friendly support team assists you at every step for a seamless experience."
  }
]

    }

const faqData = [
  {
    question: 'What is the per km rent of Force Urbania in Pune?',
    answer: 'The rent per km of Force Urbania in Pune depends on factors like the type of trip (local or outstation) and vehicle availability. Contact Amruta Travels for an exact per km rate and customized quote.'
  },
  {
    question: 'Is per km rent cost-effective for short trips?',
    answer: 'Yes, renting a Force Urbania on a per km basis is highly economical for short city trips or intercity travel, as you only pay for the distance traveled.'
  },
  {
    question: 'Does the per km rental include a driver?',
    answer: 'Yes, all per km rentals of Force Urbania include a professional and courteous driver who ensures a safe and smooth journey.'
  },
  {
    question: 'Are the Force Urbania vehicles well-maintained?',
    answer: 'Absolutely. All Force Urbania vehicles are regularly serviced, cleaned, and maintained to ensure safety, hygiene, and comfort for passengers.'
  },
  {
    question: 'Can I customize pickup and drop-off points?',
    answer: 'Yes, Amruta Travels offers flexible pickup and drop-off options along with custom routes tailored to your trip requirements.'
  },
  {
    question: 'Can I rent Force Urbania for outstation travel per km?',
    answer: 'Yes, our per km rental option is available for both local and outstation trips, providing a comfortable and cost-effective travel experience.'
  },
  {
    question: 'How can I book Force Urbania per km in Pune?',
    answer: 'You can book online, call our support team, or visit our office. Amruta Travels will help you plan the trip and provide an accurate per km rental quote.'
  },
  {
    question: 'Why choose Amruta Travels for Force Urbania per km rental in Pune?',
    answer: 'Amruta Travels offers well-maintained vehicles, professional drivers, transparent per km pricing, and dedicated support, ensuring a premium and hassle-free travel experience.'
  }
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Ramesh Jadhav',
    role: 'Corporate Manager, Pune',
    text: 'We hired Force Urbania on a per km basis for a corporate city tour. The vehicle was comfortable, clean, and the driver was professional. The per km pricing was transparent and affordable!',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Priya Patil',
    role: 'Family Trip Organizer, Pune',
    text: 'Booked a Force Urbania per km for our family outing. The ride was smooth, the vehicle spacious, and the driver courteous. Amruta Travels made our trip easy and cost-effective!',
    rating: 5
  }
];



















































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "LocalBusiness",
      "name": "Amruta Travels",
      "image": "https://bushireinpune.com/assets/images/force-urbania-rent-per-km-pune.jpg",
      "url": "https://bushireinpune.com/force-urbania-rent-per-km-pune",
      "telephone": "+91 7353109555",
      "priceRange": "₹₹",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Pune",
        "addressRegion": "Maharashtra",
        "addressCountry": "IN"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "7854"
      }
    },
    {
      "@type": "Service",
      "serviceType": "Force Urbania Rent Per KM Pune",
      "provider": {
        "@type": "LocalBusiness",
        "name": "Amruta Travels"
      },
      "areaServed": {
        "@type": "City",
        "name": "Pune"
      },
      "description": "Affordable Force Urbania per km rental in Pune for local travel, airport transfer, family trips and outstation journeys."
    },
    {
      "@type": "Product",
      "name": "Force Urbania Rent Per km in Pune",
      "image": "https://bushireinpune.com/assets/images/force-urbania-rent-per-km-pune.jpg",
      "description": "Hire Force Urbania at best per km price in Pune. Available in 12, 13, 16 and 17 seater luxury vans with AC, pushback seats and professional drivers.",
      "brand": {
        "@type": "Brand",
        "name": "Amruta Travels"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "7854"
      },
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "price": "25",
        "availability": "https://schema.org/InStock",
        "url": "https://bushireinpune.com/force-urbania-rent-per-km-pune"
      }
    },
    {
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is Force Urbania rent per km in Pune?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Force Urbania rent per km in Pune starts from ₹25 per km depending on seating capacity and trip type."
          }
        },
        {
          "@type": "Question",
          "name": "Is Urbania available for outstation travel?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, Urbania is available for Pune to Mumbai, Goa, Shirdi, Mahabaleshwar and long distance tours."
          }
        },
        {
          "@type": "Question",
          "name": "Which seating options are available in Urbania?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Urbania is available in 12, 13, 16 and 17 seater configurations."
          }
        }
      ]
    }
  ]
};


    return (
        <div>

<Helmet>
  <title>
    Force Urbania Rent Per KM in Pune | ₹25/km Urbania Hire | Call 7353109555
  </title>

  <meta
    name="description"
    content="Get best Force Urbania rent per km in Pune starting ₹25/km. Book 12, 13, 16 & 17 seater Urbania for family trips, airport transfer, corporate travel & Pune to Mumbai, Goa, Shirdi tours."
  />

  <script type="application/ld+json">
    {JSON.stringify(schemaData)}
  </script>
</Helmet>




            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/106.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Forceurbaniarentperkm;